/**
 * CSGMesh3D registration: the parser.
 */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseCSGMesh3D } from './parser';
const cSGMesh3DRegistration = {
    typeName: 'CSGMesh3D',
    parser: parseCSGMesh3D,
};
nodeRegistry.register(cSGMesh3DRegistration);
//# sourceMappingURL=index.js.map